// used in slider init
import { BackgroundColor } from './backgroundColor.sliderplugin'

export function Slider5050(Slider, els) {
    const elements = Array.from(els)
    return elements.map((el) =>
        Slider(el, {
            options: {
                backgroundColorSwapping: true,
                arrows: true,
                referenceArrows: true,
                dots: true,
                referenceDotContainer: true,
                isInfinite: true,
                horizontalSlide: true,
                dotFormat: (x) => `<span class="u-visually-hidden">slide ${x}</span>`
            },
            plugins: [BackgroundColor]
        })
    )
}
